import React from 'react';
import { DAILY_TASKS } from '../content/daily';
import iconMap from '../iconMap';
import { RESOURCES } from '../content/common';

function Daily({ app }) {
  return (
    <div className="h-full w-full flex flex-col bg-gray-50 p-6 overflow-auto">
      <div className="max-w-md mx-auto w-full">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Daily Tasks</h2>
        
        <div className="space-y-4">
          {DAILY_TASKS.map((task, index) => (
            <div 
              key={index} 
              className={`bg-white backdrop-blur-lg rounded-2xl p-6 shadow-sm ${
                task.done ? 'opacity-50' : ''
              }`}
            >
              <div className="flex items-center justify-between mb-3">
                <div>
                  <h3 className="text-gray-800 font-medium">{task.name}</h3>
                  <p className="text-gray-500 text-sm">{task.description}</p>
                </div>
                <div className="flex items-center gap-2">
                  {task.rewards.currency > 0 && (
                    <div className="text-gray-600 text-sm flex items-center">
                      <span>{task.rewards.currency}</span>
                      {React.createElement(iconMap[RESOURCES.currency.id], {
                        size: 16,
                        className: "ml-1 text-blue-500"
                      })}
                    </div>
                  )}
                  {task.rewards.premiumCurrency > 0 && (
                    <div className="text-gray-600 text-sm flex items-center">
                      <span>{task.rewards.premiumCurrency}</span>
                      {React.createElement(iconMap[RESOURCES.premiumCurrency.id], {
                        size: 16,
                        className: "ml-1 text-purple-500"
                      })}
                    </div>
                  )}
                </div>
              </div>
              
              <div className="w-full bg-gray-100 rounded-full h-2 mb-3">
                <div 
                  className="bg-blue-500 h-2 rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${(task.progress / task.required) * 100}%` }}
                />
              </div>

              <div className="flex justify-end">
                {task.completed && !task.done ? (
                  <div className="flex items-center gap-2">
                    <button 
                      onClick={() => {
                        task.done = true;
                        app.showReward({ 
                          currency: task.rewards.currency,
                          premiumCurrency: task.rewards.premiumCurrency 
                        });
                      }}
                      className="bg-blue-500 text-white px-6 py-2 rounded-full text-sm font-medium shadow-sm hover:bg-blue-600 transition-colors flex items-center relative"
                    >
                      Collect
                      <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></div>
                    </button>
                  </div>
                ) : task.done ? (
                  <div className="text-green-500 px-4 py-2 text-sm">
                    Collected
                  </div>
                ) : (
                  <div className="bg-gray-100 text-gray-600 px-4 py-2 rounded-full text-sm">
                    {task.progress}/{task.required}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Daily;
